export default {
  app: {
    railsEnv: 'staging'
  },
  project: {
    copySourceBaseUrl: 'https://fundinno-stg6dw.com',
  }
}
